import React from 'react';
import {pluralize} from 'lib/stringUtils';
import QuestionsListHeader from 'components/PracticeView/QuestionsListHeader/QuestionsListHeader.react';
import {withRouter, WithRouterProps} from 'react-router';

import {getFolderQuestionSetsQuery} from '../folderPracticeView.queries';

interface Props extends WithRouterProps {
  selectedQuestionCount: number;
  isSelectAllQuestionSetsMode: boolean;
  toggleSelectAllQuestionSets: (e) => void;
  isRearranging: boolean;
}

const FolderPracticeViewQuestionListHeader = ({
  selectedQuestionCount,
  isSelectAllQuestionSetsMode,
  toggleSelectAllQuestionSets,
  isRearranging,
  params
}: Props) => {
  const {folderId} = params;
  const questionSetMeta = getFolderQuestionSetsQuery(folderId).getResourceMetadata();
  const questionCount = questionSetMeta.getIn(['request', 'count_of_questions']);

  return (
    <QuestionsListHeader
      heading={`${questionCount} ${pluralize('Question', questionCount)}`}
      checkboxProps={
        !isRearranging
          ? {
              checked: isSelectAllQuestionSetsMode || selectedQuestionCount === questionCount,
              'aria-hidden': false,
              onChange: toggleSelectAllQuestionSets,
              indeterminate: selectedQuestionCount > 0 && selectedQuestionCount < questionCount
            }
          : undefined
      }
      selectedQuestionCount={selectedQuestionCount}
    />
  );
};

export default withRouter(FolderPracticeViewQuestionListHeader);
